export enum HomePageWidgets {
  Aggregation = 'aggregators',
  Pipeline = 'pipeline',
  SelfaiBi = 'selfaibi',
}
